// extracted by mini-css-extract-plugin
export default {"container":"SearchQuery_container__lEbfM","searchBar":"SearchQuery_searchBar__uCgY6","wrapper":"SearchQuery_wrapper__7HTd6","loading":"SearchQuery_loading__TZNE8"};